import { ApiHttpService } from '../../../services/api-http.service';
import { AppGridServiceAbstract } from './appgrid.service.abstract';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State, toODataString } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { map } from 'rxjs/operators';
import { IDashboardFilter } from 'src/app/home/filter/filter.model';


@Injectable()
export class AppGridServerService extends AppGridServiceAbstract {
    private BASE_URL = 'http://services.odata.org/V4/Northwind/Northwind.svc/';

    constructor(_http: ApiHttpService) {
        super(_http);
    }

    public query(api: string, state: State, forceUpdate: boolean, filter: IDashboardFilter): void {
        this.fetch(api, state)
           .subscribe(x => super._valueChanges.next(x));
    }

    //Converts the filter object to a string
    private filterToString({ filter }: { filter?: string }): string {
        return filter ? `&$filter=${filter}` : '';
    }

    private fetch(api: string, state: any): Observable<GridDataResult> {
        const queryStr = `${toODataString(state)}${this.filterToString(state)}`;

        return this._http
            .get(`${this.BASE_URL}${api}?${queryStr}`)
                .lift(map((res: Response) => res.json()))
                .lift(map((json: any) => (<GridDataResult>{
                data: json.value,
                total: parseInt(json['@odata.count'], 10)
            })));
    }

    //Returns the data for the given api
    public getData(api: string): any[] {
        return [];
    }

    public setData(api: string, data: any[]) {

    }

    public deleteRowData(api: string, idField: string, id: any) {}

    public getExcelData(api: string): Observable<ExcelExportData> { return new Observable();}
}